import * as React from "react";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {FieldItemBase, FieldItemBaseProps, FieldItemBaseState} from "InternalShared/PageBuilder/Fields/FieldItemBase";
import {WPFormControlTypeEnum} from "../Controls/WPFormFactory";


export class InvoiceDetailField extends FieldItemBase<TextFieldItemProps, TextFieldItemState> {
    static defaultProps: Partial<TextFieldItemProps> = {};
    IsPR:boolean=true;

    constructor(props: TextFieldItemProps) {
        super(props);
        this.state = {

        };
    }

    protected GetImage() {
        return 'WPForm/invoice.png'
    }

    protected GetText() {
        return 'Product detail'
    }

    protected GetType() {
        return WPFormControlTypeEnum.InvoiceDetail;
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TextFieldItemProps extends FieldItemBaseProps{

}

interface TextFieldItemState extends FieldItemBaseState{

}

//#endregion "My Region"